import { useMemo } from "react";

import { Card } from "@/components/ui/card";
import { RoleplayRank } from "@/graphql";
import { formatDate } from "@/utils/datetime";

import { EmptyStateChart } from "./EmptyStateChart";
import { ProgressionChart } from "./ProgressionChart";

interface SessionHistoryChartSectionProps {
  sessions: {
    uuid: string;
    updatedAt: string;
    rank: RoleplayRank;
    score: number;
    scenarioSlug?: string;
  }[];
  scenarioSlug?: string;
}

export const SessionHistoryChartSection = ({
  sessions,
  scenarioSlug = "",
}: SessionHistoryChartSectionProps) => {
  // Convert sessions to progression chart data
  const progressionData = useMemo(() => {
    if (!sessions || sessions.length === 0) return [];

    return sessions
      .filter((session) => session !== null)
      .map((session) => ({
        score: session?.score || 0,
        date: formatDate(session?.updatedAt, "MMM do 'at' h:mm a") || "",
        rank: (session?.rank as RoleplayRank) || RoleplayRank.Unranked,
        scenarioSlug: session?.scenarioSlug || scenarioSlug || "",
        sessionUuid: session?.uuid || "",
      }))
      .reverse(); // Reverse to show chronological order
  }, [sessions]);
  return (
    <div className="space-y-3">
      <h3 className="font-semibold text-base text-black">Progression</h3>
      <Card className="p-6 border border-neutral-300 bg-white">
        {progressionData.length > 0 ? (
          <ProgressionChart data={progressionData} />
        ) : (
          <EmptyStateChart />
        )}
      </Card>
    </div>
  );
};
